import React, { useState, memo } from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useKeycodeListener } from '@shared/utils/hooks/useKeycodeListener';

const KEY_CODE_H = 'H'.charCodeAt(0);

const REVEAL_HOTKEYS = [KEY_CODE_H] as const;

interface OtaProviderNameProps {
  readonly otaProvider?: string | null;
}

export const OtaProviderName = memo<OtaProviderNameProps>(({ otaProvider }) => {
  const [showProviderName, setShowProviderName] = useState(false);

  const toggleProviderName = useEventCallback(() => {
    setShowProviderName(prev => !prev);
  });

  useKeycodeListener(REVEAL_HOTKEYS, toggleProviderName, { ctrlKey: true, shiftKey: true }, REVEAL_HOTKEYS);

  if (!showProviderName || !otaProvider) {
    return null;
  }

  return (
    <Flex
      paddingX={2}
      paddingY={1}
      marginTop={2}
      width="fit-content"
      alignItems="center"
      backgroundColor="mono10"
      borderRadius={pxToRem(4)}
    >
      <TextV2
        color="white"
        fontSize={12}
        typographyVariant="body2"
      >
        {otaProvider}
      </TextV2>
    </Flex>
  );
});

OtaProviderName.displayName = 'OtaProviderName';
